/// <amd-module name="Feed/Common/Types/IGeneralDialogProps" />
import * as React from "react";

export interface IGeneralDialogProps {
    headerText: string;
    onSaveCallback: (parameter?: string) => void;
    onDismissCallback: () => void;
    saveButtonText: string;
    confirmText?: string;
    confirmTextLearnMoreLink?: string;
    dialogClassName?: string;
    messageBarMessage?: string;
    onSavePrimaryButtonText?: string;
    saveButtonClassName?: string;
    saveButtonDisabled?: boolean;
    severeWarningText?: string;
    severeWarningLearnMoreLink?: string;
    textField?: boolean;
    textFieldDefaultValue?: string;
    textFieldLabel?: string;
    textFieldPlaceholder?: string;
}
